import React, { Component } from "react";
import "../js/appConstants.js";
import MyBlogs from "../js/codeandtech/MyBlogs";
import HomeCloudOpsGuru from "./cloudopsguru/HomeCloudOpsGuru.js";
import HomeCodeAndTech from "./codeandtech/HomeCodeAndTech.js";

class Home extends Component {
  render() {
    const isCat = window.appConstants.AppName === "CodeAndTech";
    return (
      <div className="home-page">
        {isCat ? <HomeCodeAndTech /> : <><HomeCloudOpsGuru /><MyBlogs /></>}
      </div>
    );
  }
}

export default Home;
